import { MemberStatusEnumValues, OrganizationMemberRoleEnumValues } from '@forgd/shared/enums'
import { z } from 'zod'

export const LiquidityInviteMemberRequestBody = z.object({
  email: z.string().toLowerCase().trim().email({ message: 'Email is invalid' }),
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
})

export const LiquidityResendInvitationRequestBody = z.object({
  memberId: z.string().uuid(),
})

export const LiquidityDeleteMemberRequestBody = z.object({
  memberId: z.string().uuid(),
})

export const LiquidityMemberDetailsBody = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  email: z.string().email().optional(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  status: z.enum(MemberStatusEnumValues),
  role: z.enum(OrganizationMemberRoleEnumValues),
  invitedAt: z.string().datetime().nullable(),
})

export const LiquidityGetMembersResponseBody = z.object({
  members: z.array(LiquidityMemberDetailsBody),
  organizationId: z.string().uuid(),
})

export type LiquidityInviteMemberRequestBody = z.infer<typeof LiquidityInviteMemberRequestBody>
export type LiquidityMemberDetailsBody = z.infer<typeof LiquidityMemberDetailsBody>
